var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-error"},[_c('img',{attrs:{"src":_vm.errorImg}}),_vm._v(" "),_c('p',{staticClass:"error"},[_vm._v(_vm._s(this.errorText))]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"28px"}},[_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("返回")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1425d5de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/layout/error-page/404.vue
// module id = null
// module chunks = 